<template>
<div class="chapter">
<div class="inner_page">
<p class="normal"><b>Books by Terri Blackstock</b></p>
<p class="bodytext"><em>Cape Refuge</em> (Book 1 in series) </p>
<p class="bodytext"><em>Emerald Windows</em></p>
<p class="normal"><b>Newpointe 911</b></p>
<p class="bodytext"><em>Private Justice</em></p>
<p class="bodytext"><em>Shadow of Doubt</em></p>
<p class="bodytext"><em>Trial by Fire</em></p>
<p class="bodytext"><em>Word of Honor</em></p>
<p class="normal"><b>Sun Coast Chronicles</b></p>
<p class="bodytext"><em>Evidence of Mercy</em></p>
<p class="bodytext"><em>Justifiable Means</em></p>
<p class="bodytext"><em>Ulterior Motives</em></p>
<p class="bodytext"><em>Presumption of Guilt</em></p>
<p class="normal"><b>Second Chances</b></p>
<p class="bodytext"><em>Never Again Good-bye</em></p>
<p class="bodytext"><em>When Dreams Cross</em></p>
<p class="bodytext"><em> Blind Trust</em></p>
<p class="bodytext"><em>Broken Wings</em></p>
<p class="normal"><b>With Beverly LaHaye</b></p>
<p class="bodytext"><em>Seasons Under Heaven</em></p>
<p class="bodytext"><em> Showers in Season</em></p>
<p class="bodytext"><em> Times and Seasons</em> </p>
<p class="bodytext"><em>Season of Blessing</em></p>
<p class="normal"><b>Novellas</b></p>
<p class="bodytext"><em>Seaside</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003adpage.vue?8ecd3a92